module.exports = __webpack_public_path__ + "static/drake-no-bf42d87af02fff1e35e6af013a6f4681.png";